module.exports = __webpack_public_path__ + "img/radslag.78a510ec.jpg";